module.exports = __webpack_public_path__ + "static/media/app-bg.f6eee84c.png";